import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMyBetsKenoGameService, placeBetKenoGameService } from '../services/kenoGame.service'
import { openErrorToaster } from 'helpers/toaster.helpers'
import { appendMyBetsKeno, setKenoGameLosses, setKenoGameProfit, setKenoGameWagered, setKenoGameWins } from './kenoGame.slice'
import { kenoGameDemoPlaceBetService } from '../GameTheme/KenoGame/kenoGame.helper'

export const placedBetKenoGame = createAsyncThunk('keno-game/place-bet',
  async ({ payload, placeBetData, isDemoGame }, thunkApi) => {
    try {
      let res
      if (!isDemoGame) res = await placeBetKenoGameService(payload)
      else res = kenoGameDemoPlaceBetService(payload)

      thunkApi.dispatch(setKenoGameWagered(res?.betAmount))
      thunkApi.dispatch(appendMyBetsKeno({ placeBetData: res }))
      if (res?.result === 'won') {
        thunkApi.dispatch(setKenoGameWins())
        thunkApi.dispatch(setKenoGameProfit(res?.winningAmount - res?.betAmount))
      } else if (res?.result === 'lost') {
        thunkApi.dispatch(setKenoGameLosses())
        thunkApi.dispatch(setKenoGameProfit(res?.winningAmount - res?.betAmount))
      }
      return res
    } catch (error) {
      console.error(error, 'ERROR')
      openErrorToaster({ message: 'Place Bet Failed' })
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const getMyBetsKeno = createAsyncThunk('keno-game/myBets', async (params, thunkApi) => {
  try {
    const res = await getMyBetsKenoGameService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getMyAllBetsKeno = createAsyncThunk('keno-game/myAllBets', async (params, thunkApi) => {
  try {
    const res = await getMyBetsKenoGameService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})
